import AddressCompanyNameField from 'components/AddressModal/components/AddressCompanyNameField/styled';

export default AddressCompanyNameField;
